module.exports = __webpack_public_path__ + "static/r3-2b10ef4c7d1d8b7c8754e6f742590c98.jpg";